import React, { FunctionComponent } from "react";
import { ICardElementWithChildren } from "backend/model/model";
import TextElement from "reportengine/TextElement";
import Text from "reportengine/Text";
import Slide from "reportengine/Slide";
import DomElement from "reportengine/DomElement";
import Portion from "reportengine/Portion";
import { formatDate, getDateFromMEAValue } from "utils/utils";
import PerformanceTrend from "components/PerformanceTrend";
import { PerformanceDonut } from "design/components/charts/PerformanceDonut";
import ProgressBar2 from "design/components/progress/PercentageBar";
import ReportComments from "../components/ReportComment";
const InitiativeSlide = (
  props: React.PropsWithChildren<{
    item: ICardElementWithChildren;
  }>
) => {
  const { item } = props;
  const sign = Number(props.item?.SLIPPAGE) > 0 ? "+" : "-";
  const slippageNumber = Number(props.item?.SLIPPAGE);
  const slippageText = isNaN(slippageNumber)
    ? ""
    : String(Math.abs(slippageNumber));
  const startDate = formatDate(
    getDateFromMEAValue(props.item.START_DATE),
    "en-GB",
    true
  );
  const endDate = formatDate(
    getDateFromMEAValue(props.item.END_DATE),
    "en-GB",
    true
  );
  //   const lastPeriod = useYearsLastPeriod(item.period?.name || "");
  return (
    <>
      <Slide index={9}>
        <TextElement slideElement="footer">
          {item["scorecardname"]} (Initiative)
        </TextElement>
        <Text slideElement="period">
          <Portion paragraphIndex={0} portionIndex={0}>
            {item.period?.name || ""}
          </Portion>
        </Text>

        <ReportComments
          item={props.item}
          slideElement="justification_text"
          justificationDateElement="justification_date"
          justificationOwnerElement="justification_owner"
          justificationOwnerNameElement="justification_owner_name"
        />

        {item.SLIPPAGE ? (
          <TextElement slideElement="slippage_status">
            {Number(item.SLIPPAGE) > 0
              ? "Behind Schedule"
              : "Ahead of Schedule"}
          </TextElement>
        ) : null}

        <Text slideElement="start_and_end_date">
          <Portion portionIndex={1} paragraphIndex={0}>
            {`${startDate}– `}
          </Portion>
          <Portion portionIndex={3} paragraphIndex={0}>
            {`${endDate}`}
          </Portion>
        </Text>
        <TextElement slideElement="header">{item.parentName}</TextElement>
        <Text slideElement="budget_util">
          <Portion portionIndex={2} paragraphIndex={0}>
            {props.item?.period?.name}
          </Portion>
        </Text>
        <Text slideElement="variance">
          <Portion portionIndex={0} paragraphIndex={0}>
            {props.item?.VARIANCE_prettyvalue}
          </Portion>
        </Text>
        <Text slideElement="planned_progress">
          <Portion portionIndex={0} paragraphIndex={0}>
            {props.item?.PLANNED_COMPLETION_prettyvalue}
          </Portion>
        </Text>
        <Text slideElement="estimated_end_date">
          <Portion portionIndex={0} paragraphIndex={0}>
            {endDate}
          </Portion>
          <Portion portionIndex={1} paragraphIndex={0}></Portion>
          <Portion portionIndex={2} paragraphIndex={0}></Portion>
        </Text>
        <Text slideElement="ytd_expenditure">
          <Portion portionIndex={0} paragraphIndex={0}>
            YTD Expenditure
          </Portion>
          <Portion portionIndex={3} paragraphIndex={0}>
            {props.item.EXPENDITURE_prettyvalue}
          </Portion>
        </Text>
        <Text slideElement="slippage_duration">
          <Portion portionIndex={0} paragraphIndex={0}>
            {sign}
          </Portion>
          <Portion portionIndex={1} paragraphIndex={0}>
            {slippageText}
          </Portion>
        </Text>
        <TextElement slideElement="name">{props.item.name}</TextElement>
        <Text slideElement="total_budget">
          <Portion portionIndex={2} paragraphIndex={0}>
            {props.item?.BUDGET_prettyvalue}
          </Portion>
        </Text>
        <TextElement slideElement="progress_title">
          Progress {props.item.period?.name}
        </TextElement>
        <DomElement
          typename="image"
          selector=".element"
          slideElement="budget_util_chart"
          transform={{
            x: -20,
            width: 240,
            height: 240,
          }}
        >
          <div className="element" style={{ width: "300px", height: "300px" }}>
            <PerformanceDonut
              colorKey="rangecolor"
              disableAnimation
              element={item}
              prettyKey="BUDGET_UTIL_prettyvalue"
              valueKey="BUDGET_UTIL"
            />
          </div>
        </DomElement>

        <DomElement
          typename="image"
          selector=".element"
          slideElement="progress_bar"
          transform={{}}
        >
          <div className="element" style={{ width: "300px", height: "60px" }}>
            <ProgressBar2
              color={`#${item.rangecolor}`}
              value={Number(item.COMPLETION_PERCENTAGE)}
            />
            {/*                
            <ProgressBar
              value={Number(item.COMPLETION_PERCENTAGE)}
              title={item.COMPLETION_PERCENTAGE_prettyvalue}
              bgColor={`#${item.rangecolor}33`}
              barColor={`#${item.rangecolor}ff`}
            />

        */}
          </div>
        </DomElement>
        <DomElement
          typename="image"
          selector=".highcharts-root"
          slideElement="progress_trend_chart"
          transform={{
            y: 70,
            height: -20,
            width: -30,
          }}
        >
          <div style={{ width: "1090px", height: "300px" }}>
            <PerformanceTrend
              disableAnimation
              width="1090px"
              element={props.item}
              series={[
                {
                  key: "PLANNED_COMPLETION",
                  name: "TARGET",
                  color: "rgb(93,98,104)",
                },
                {
                  key: "COMPLETION_PERCENTAGE",
                  name: "ACTUAL",
                  color: "rgba(38, 166, 242, 0.8)",
                },
              ]}
            />
          </div>
        </DomElement>
      </Slide>
    </>
  );
};

export default InitiativeSlide;
